import { FormattedText, FormattedTextProps } from '@sonyged/formatted-text'

export type RubyTextProps = FormattedTextProps

export const RubyText = FormattedText
